<template>
  <section>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 查询条件 -->
    <el-form
      ref="searchForm"
      :model="searchForm"
      label-width="100px"
      inline
      class="demo-form-inline"
      size="small"
      style="border-bottom: 1px solid var(--table-border)"
    >
      <el-form-item label="状态" prop="state">
        <el-select v-model="searchForm.state" placeholder="全部">
          <el-option label="待发货" value="0"></el-option>
          <el-option label="已完成" value="1"></el-option>
          <el-option label="发货中" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
    <btns @exec="exec"></btns>
    <div class="data-container scroll-table">
      <!-- 库存列表 -->
      <el-table
        :data="tableData"
        border
        class="mgt-18"
        style="width: 100%"
        @selection-change="tableSelectionChange"
      >
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column prop="customerName" label="订单编号">
        </el-table-column>
        <el-table-column prop="customerName" label="采购商">
        </el-table-column>
        <el-table-column prop="customerName" label="品牌"> </el-table-column>
        <el-table-column prop="customerName" label="规格">
        </el-table-column>
        <el-table-column prop="customerName" label="数量">
        </el-table-column>
         <el-table-column prop="customerName" label="收货地">
        </el-table-column>
        <el-table-column prop="customerName" label="状态"> </el-table-column>
        <el-table-column prop="customerStatus" label="操作">
          <template slot-scope="scope">
            <button v-if="scope.row.customerStatus == 0" type="danger">
              查看物流
            </button>
            <button v-if="scope.row.customerStatus == 1">自动分单</button>
            <button v-if="scope.row.customerStatus == 2">查看订单</button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mgt-10 pd-0"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="searchForm.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="searchForm.totalCount"
      >
      </el-pagination>
    </div>
    <!-- 查看物流 -->
    <el-dialog
      title="物流信息"
      :visible.sync="logisticsDialogVisible"
      width="30%"
      center>
      <div class="block">
        <el-timeline :reverse="reverse">
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            :timestamp="activity.timestamp">
            {{activity.content}}
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-dialog>
    <!-- 出库单 -->
    <el-dialog
      title="共享充电宝回收"
      :visible.sync="warehouseWarrantDialogVisible"
      center
    >
      <div class="center"><p class="title">出库单</p></div>
      <div class="flex-between mgb-5 pdr-10 pdl-20">
        <span>入库单编号:No.203974878</span>
        <span>发货回收站:成都武侯区天府广场回收驿站</span>
      </div>
      <div class="flex-between row el-button--primary mgb-10">
        <span>发货人:张三</span>
        <span>联系电话:13684444444</span>
        <span>发货地址:四川省成都市武侯区233号</span>
      </div>
      <div class="flex hgt45 row">
        <span class="flex1">编号</span> <span class="flex1">品牌名称</span> <span class="flex1">单位</span><span class="flex1">数量</span>
      </div>
      <div class="flex hgt45 row">
        <span class="flex1">1</span><span class="flex1">街电</span><span class="flex1">个</span> <span class="flex1">100</span>
      </div>
      <div class="flex hgt45 row"><span class="flex1">备注:备注说明</span></div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </section>
</template>

<script>
import btns from "@/components/btns.vue";
import breadcrumbs from "@/components/breadcrumbs.vue";
import Button from "../sys/button.vue";

export default {
  components: {
    btns,
    breadcrumbs,
  },
  data() {
    return {
      searchForm: {
        totalCount: 0,
        current: 1,
        size: 10,
        orderNo: "",
        state: "", 
      },
      logisticsDialogVisible: true, //查看物流
      warehouseWarrantDialogVisible: false, //出库单
      tableData: [],
      tableSelection: [],
      dialogImageUrl: "",
      dialogVisible: false,
      reverse: true,
      img1:require("../../img/待发货.png"),
      img2:require("../../img/待发货总数.png"),
      img3:require("../../img/今日新增出库单.png"),
      img4:require("../../img/已发货总数.png"),
      img5:require("../../img/已完成单数.png"),
      activities: [
        {
          content: "【绵阳市】已签收,签收人:黄油",
          timestamp: "2020-12-17 13:35:20",
          color: '#0bbd87'
        },
        {
          content: "【绵阳市】快件派送中，派件人:黄瓜,电话:1366666666",
          timestamp: "2020-12-17 13:35:20",
        },
        {
          content: "【绵阳市】快件已到达绵阳市***营业点",
          timestamp: "2020-12-17 13:35:20",
        },{
          content: "【成都市】成都市武侯区仓库已发出",
          timestamp: "2020-12-17 13:35:20",
        },
      ],
    };
  },
  created() {
    this.query();
  },
  methods: {
    handleSizeChange(v) {
      this.searchForm.size = v;
      this.query();
    },
    handleCurrentChange(v) {
      this.searchForm.current = v;
      this.query();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.search();
    },
    search() {
      if (this.searchForm.name) {
        this.tableData = this.tableData.filter(
          (e) => e.btnName.indexOf(this.searchForm.name) >= 0
        );
      } else {
        this.query();
      }
    },
    query() {
      //获取接口
      this.$api.outorder
        .getHouseOutOrderList(this.searchForm)
        .then((d) => {
          if (d.code == 200) {
            this.tableData = d.data;
          } else {
            this.$message.error(d.msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    tableSelectionChange(val) {
      this.tableSelection = val;
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
  },
};
</script>
<style scoped lang='less'>
.grid-content {
  display: flex;
  padding: 15px 10px;
  background-color: aliceblue;
  .img {
    width: 75px;
    height: 75px;
  }
  .total {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    flex: 1;
    padding-left: 10px;
  }
  p {
    margin: 0;
    display: flex;
    align-items: baseline;
  }
}
.font36 {
  font-size: 36px;
  margin-right: 5px;
}
.row{
  padding: 10px;
  min-height: 35px;
  box-sizing: border-box;
  border: 1px solid var(--table-border);
}
.flex1{
  flex:1;
  text-align: center;
}
.border-8e{
  border: 1px solid var(--table-border);
}
.title{
  font-size: 28px;
  text-align: center;
  margin: 0 0px 20px 0px;
  display: inline-block;
  padding-bottom: 4px;
  border-bottom:2px solid var(--input-border);
  margin-bottom: 20px;
}
</style>